<div style="display: flex; flex-direction: column;">
    <h1 style="display: flex; justify-content: center;">You have been logged out. Please login to access iManage.</h1>
    <div style="display: flex; justify-content: center;">
        <button [routerLink]="['/home']">Login</button>
    </div>
</div>